import React from 'react';
import { DependencyUpdateProvider } from './DependencyUpdateProvider';
import { EmailListProvider } from './EmailListProvider';
import { EmailProvider } from './EmailProvider';
import { InboxProvider } from './InboxProvider';
import { ThreadReadsProvider } from './ThreadReadsProvider';
import { OnboardingModalsProvider } from './OnboardingModalsProvider';
import { PlanModalProvider } from './PlanModalProvider';
import { ResponseArtifactEventProvider } from './ResponseArtifactEventProvider';

interface ProvidersProps {
  children: React.ReactNode;
}

/**
 * Combined providers wrapper that sets up the dependency update, email list, and email providers
 * in the correct order (dependency updates first, then email providers which depend on it)
 */
export const Providers: React.FC<ProvidersProps> = ({ children }) => {
  return (
    <DependencyUpdateProvider>
      <OnboardingModalsProvider>
        <PlanModalProvider>
          <EmailListProvider>
            <EmailProvider>
              <InboxProvider>
                <ThreadReadsProvider>
                  <ResponseArtifactEventProvider>
                    {children}
                  </ResponseArtifactEventProvider>
                </ThreadReadsProvider>
              </InboxProvider>
            </EmailProvider>
          </EmailListProvider>
        </PlanModalProvider>
      </OnboardingModalsProvider>
    </DependencyUpdateProvider>
  );
};

// Re-export hooks for convenience
export { useDependencyUpdates } from './DependencyUpdateProvider';
export { useEmailList } from './EmailListProvider';
export { useEmail } from './EmailProvider';
export { useInbox } from './InboxProvider';
export { useThreadReads } from './ThreadReadsProvider';
export { useOnboardingModals } from './OnboardingModalsProvider';
export { usePlanModal } from './PlanModalProvider';
export { useResponseArtifactEvents } from './ResponseArtifactEventProvider';
